import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { OrderBy } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/booking_submission.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { InfiniteQueryResult } from '@frontend/types';
import { DEFAULT_SCHEDULE_REQUEST_STATUSES_PARAM_V3 } from '../../../../../../constants';
import { convertScheduleRequestV3ToV2 } from './useGetScheduleRequest';

export const useGetPendingRequestsV3InfiniteQuery = (
  locationIds: string[],
  combineBookingRequests = false
): InfiniteQueryResult<{ rows: ScheduleRequest[]; totalCount: number }> => {
  const { isScheduleV3FlagEnabled, isLoading: isLoadingFF } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const scheduleRequestListQueryV3 = SchedulerV3.Queries.useListBookingSubmissionsInfiniteQuery({
    request: {
      locationsIds: locationIds,
      limit: 25,
      reviewedStatuses: DEFAULT_SCHEDULE_REQUEST_STATUSES_PARAM_V3,
      orderBy: OrderBy.CREATED_AT, // By default it will be order by descending
    },
    options: {
      enabled: !isLoadingFF && isScheduleV3FlagEnabled && locationIds.length > 0 && !combineBookingRequests,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      select: (data) => {
        return {
          ...data,
          pages: data.pages.map((page, index) => ({
            rows: (page.bookingSubmissions ?? []).map<ScheduleRequest>(convertScheduleRequestV3ToV2),
            totalCount: page.totalCount ?? 0,
            page: index + 1,
            totalPages: Math.ceil((page.totalCount ?? 0) / 25),
          })),
        };
      },
    },
  });

  return scheduleRequestListQueryV3;
};
